/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestCommentDto } from '../../models/contents-request-comment-dto';

export interface ContentsRequestCommentControllerDelete$Params {
  commentId: string;

/**
 * 고객사 ID
 */
  clientWorkspaceId?: string;
}

export function contentsRequestCommentControllerDelete(http: HttpClient, rootUrl: string, params: ContentsRequestCommentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestCommentDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestCommentControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('commentId', params.commentId, {});
    rb.query('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestCommentDto>;
    })
  );
}

contentsRequestCommentControllerDelete.PATH = '/api/contents-request-comment/{commentId}';
